module.exports = __webpack_public_path__ + "6862f21fbc8a48a005827dfaed3fa707.jpg";